import { Grid } from '@mui/material';
import { parseHMtoSeconds, parseSecondsToHM } from '@nx-smartmonkey/shared/helpers';
import { TimeWindow } from '@nx-smartmonkey/shared/interfaces';
import { HSpacer, VSpacer } from '@nx-smartmonkey/ui';

import { useState } from 'react';
import { useIntl } from 'react-intl';
import { parseTimewindowToExcel } from '../../../helpers/excel/Parsers';
import Button from '../../../react-components/Button';
import { InputTimePicker } from '../../../react-components/InputTimePicker';
import Text from '../../../react-components/Text';
import eventsPanel from '../../../services/events';
import { AnimatedStep } from './AnimatedStep';

interface VehiclesTimeWindowProps {
  vehiclesTimeWindow: TimeWindow;
  onChange: (vehiclesTimeWindow: TimeWindow) => void;
  onNextStep: () => void;
}

export const VehiclesTimeWindow = ({ vehiclesTimeWindow, onChange, onNextStep }: VehiclesTimeWindowProps) => {
  const intl = useIntl();
  const [animationVisible, setAnimationVisible] = useState<boolean>(true);
  return (
    <AnimatedStep id="vehiclesTimeWindowsAnimatedContainer" isVisible={animationVisible}>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ padding: `20px`, maxWidth: `660px`, position: `relative` }}
      >
        <Grid item>
          <Text variant="h6" intlId="company.onboarding.vehicles.time_window.info" />
        </Grid>

        <VSpacer medium />

        <Grid item container direction="row" wrap="nowrap">
          <Grid item container direction="row" wrap="nowrap" alignItems="center" style={{ width: `unset` }}>
            <Grid item>
              <Text variant="label" intlId="from" />
            </Grid>

            <HSpacer small />

            <Grid item>
              <InputTimePicker
                inputStyles={{
                  width: `237px`,
                }}
                timeValue={parseSecondsToHM(vehiclesTimeWindow[0])}
                onChange={(time: string) => {
                  onChange([parseHMtoSeconds(time), vehiclesTimeWindow[1]]);
                }}
              />
            </Grid>
          </Grid>

          <HSpacer small />

          <Grid item container direction="row" wrap="nowrap" alignItems="center" style={{ width: `unset` }}>
            <Grid item>
              <Text variant="label" intlId="to" style={{ textTransform: `lowercase` }} />
            </Grid>

            <HSpacer small />

            <Grid item>
              <InputTimePicker
                inputStyles={{
                  width: `237px`,
                }}
                timeValue={parseSecondsToHM(vehiclesTimeWindow[1])}
                onChange={(time: string) => {
                  onChange([vehiclesTimeWindow[0], parseHMtoSeconds(time)]);
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <VSpacer small />

        <Grid item>
          <Text variant="label" style={{ fontSize: `11px` }}>{`*${intl.formatMessage({
            id: `company.onboarding.vehicles.time_window.hint`,
          })}`}</Text>
        </Grid>

        <Grid
          item
          container
          direction="row"
          wrap="nowrap"
          alignItems="center"
          justifyContent="center"
          style={{ position: `absolute`, bottom: `-60px` }}
        >
          <Button
            intlId="company.onboarding.next"
            style={{
              width: `200px`,
              height: `32px`,
            }}
            onClick={() => {
              setAnimationVisible(false);
              setTimeout(() => {
                onNextStep();
                eventsPanel.onboardingPageView({
                  page: `vehiclesTimeWindow`,
                  data: { timeWindow: parseTimewindowToExcel(vehiclesTimeWindow) },
                });
              }, 500);
            }}
          />
        </Grid>
      </Grid>
    </AnimatedStep>
  );
};
